import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "../../i18n";
import { fetchCurrentUser } from "../../utils/api";

export default function RequireAuth() {
  const { t } = useTranslation();
  const location = useLocation();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let active = true;

    const checkSession = async () => {
      const { user } = await fetchCurrentUser();
      if (!active) return;
      setStatus(user ? "authenticated" : "unauthenticated");
    };

    checkSession();

    return () => {
      active = false;
    };
  }, []);

  if (status === "checking") {
    return (
      <div className="dash-page">
        <div className="dash-container">
          <div className="dash-skeleton">{t("common.checkingSession")}</div>
        </div>
      </div>
    );
  }

  if (status !== "authenticated") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
